// removed by extract-text-webpack-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl_ibcUQ","Label":"BuildControl_Label_2VLnR","Less":"BuildControl_Less_3X6hg","More":"BuildControl_More_2eQpV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BuildControls/BuildControl/BuildControl.css
// module id = 132
// module chunks = 3